// 引入首页
import home from './component/home.vue'
// 引入精品文物
import jpww from './component/jpww.vue'
// 引入专题研究
import ztyj from './component/ztyj.vue'
// 引入红色动态
// import hsdt from './component/hsdt.vue'
// 引入账号管理
import zhgl from './component/zhgl.vue'
// 引入部门管理
import bmgl from './component/bmgl.vue'
// 引入岗位管理
import gwgl from './component/gwgl.vue'
import axios from 'axios'
export default {
  name: 'backStage',
  components: { home, jpww, ztyj, zhgl, bmgl, gwgl },
  data () {
    return {
      loading: false,
      // 用户名
      userName: '',
      // 导航list
      naviList: [
        {
          name: '首页',
          id: 'home',
          show: '1'
        },
        {
          name: '精品文物',
          id: 'jpww',
          show: '0'
        },
        {
          name: '专题研究',
          id: 'ztyj',
          show: '0'
        },
        // {
        //   name: '红色动态',
        //   id: 'hsdt'
        // },
        {
          name: '系统管理',
          id: 'xtgl',
          show: '0'
        }
      ],
      // 系统管理下的三个管理
      xtglList: [
        {
          name: '账号管理',
          id: 'zhgl'
        },
        {
          name: '部门管理',
          id: 'bmgl'
        },
        {
          name: '岗位管理',
          id: 'gwgl'
        }
      ],
      // 选中导航的id
      naviSelect: '',
      // 选中系统管理的id
      xtglSelect: ''
    }
  },
  // 创建元素
  mounted () {
    this.init()
    this.getPortal()
  },
  // 方法定义
  methods: {
    // 初始化
    init () {
      if (localStorage.getItem('userName')) {
        this.userName = localStorage.getItem('userName')
      } else {
        this.userName = ''
      }
      const selectName = this.$route.name
      if (selectName === 'zhgl' || selectName === 'bmgl' || selectName === 'gwgl') {
        this.naviSelect = 'xtgl'
        this.xtglSelect = selectName
        return
      }
      this.naviSelect = selectName
      this.xtglSelect = ''
    },

    // 请求权限
    getPortal () {
      const self = this
      self.loading = true
      axios.get('/yuhuamenhu/user/getPortalPermissionByName').then(json => {
        if (json.data.code === 200) {
          const data = json.data.data
          self.naviList[1].show = data.relic
          self.naviList[2].show = data.special
          self.naviList[3].show = data.system
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loading = false
      })
    },

    // 点击导航切换
    clickNavi (item) {
      if (item.id === this.naviSelect) {
        return
      }
      this.naviSelect = item.id
      this.xtglSelect = ''
      if (item.id !== 'xtgl') {
        this.$router.push(item.id)
      }
    },

    // 点击系统管理切换
    clcikXtgl (param) {
      if (param.id === this.xtglSelect) {
        return
      }
      this.xtglSelect = param.id
      this.$router.push(param.id)
    },

    // 退出登录
    signOut () {
      const self = this
      axios.post('/yuhuamenhu/user/logout').then(json => {
        if (json.data.code === 201) {
          self.$store.commit('del_Authorization')
          self.$store.commit('del_name')
          self.$store.commit('del_userName')
          self.$store.commit('del_userType')
          self.$store.commit('del_userKind')
          this.$router.replace({
            path: '/login'
          })
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
